import type { IOpportunity } from "src/services/api/opportunities/types"

export const getObjectiveListKey = (objective: IOpportunity): string =>
    objective.objective_id || `${objective.title}-${objective.createdDate}`
